import React, { Component } from 'react'
import { firebaseDb as db } from '../firebase'

class Home extends Component {
  // Keep button for testing security rules
  debugButton (e) {
    db
      .collection('settings')
      .doc('security')
      .get()
      .then(response => {
        console.log(response)
        console.log('Document data:', response.data())
      })
      .catch(e => {
        console.log(e)
      })
  }

  render () {
    return (
      <div>
        <h1>CallBuddy by W4</h1>
        <p><b>Manage call center contacts</b> in one simple application, just log in to see the magic.</p>
        <p>
          For registration contact your manager, which will generate you an account. Then you will receive an email with an invitation to see all your projects.
        </p>
        {/* <button onClick={this.debugButton}>Debug button</button> */}
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js